import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular';
import { MessagingService } from 'src/app/services/messaging.service';

@Component({
  selector: 'app-note-modal',
  templateUrl: './note-modal.page.html',
  styleUrls: ['./note-modal.page.scss'],
})
export class NoteModalPage implements OnInit {
  public contact;
  
  frmAddNote: UntypedFormGroup;

  constructor(
    public navParams: NavParams,
    private modalController: ModalController,
    public messaging:MessagingService,
  ) { 
    this.frmAddNote = new UntypedFormGroup({
      "noteMessage": new UntypedFormControl(null, [Validators.required])
    });
  }

  ngOnInit() {
    this.contact = this.navParams.data.contact;
  }

  close(){
    this.modalController.dismiss();
  }

  saveNote(){    
    this.messaging.sendAsNote(this.frmAddNote.get('noteMessage').value,this.contact).then(() => {
      this.close();
    });
  }

}
